/**
 * A dónde se puede ir desde cualquier número o alerta de esta app.
 *
 * Una pantalla de ESTA app se abre con `navegar`; una de OTRA mini-app
 * (conciliación, operación) es un enlace, porque cada público tiene su
 * bundle (D003) y cruzar de uno a otro es cambiar de página, no de pestaña.
 * Lo que no esté en ninguna de las dos listas no es un destino y el botón
 * no se dibuja: mejor ningún botón que uno que no lleva a ningún lado.
 */

export interface Destino {
  pantalla: string;
  parametros?: Record<string, unknown>;
}

export type Navegar = (destino: Destino) => void;

/** Las pantallas que ESTA app sabe dibujar, por su id en `sistema.pantalla`. */
export const CONSTRUIDAS = new Set(["tablero", "territorio", "mapa", "metas", "supuestos", "estructura", "usuarios", "eventos"]);

/** Las que viven en otra mini-app, con su puerta. */
export const EXTERNAS: Record<string, string> = {
  conciliacion: "/app/conciliacion/",
  operacion: "/app/operacion/",
  campo: "/app/campo/",
};

export function esConstruida(pantalla: string): boolean {
  return CONSTRUIDAS.has(pantalla);
}

export function enlaceExterno(pantalla: string): string | null {
  return EXTERNAS[pantalla] ?? null;
}
